export const NutritionFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M2 13.667C2 8.187 6.197 3.69 11.551 3.21c-.096.39-.178.78-.25 1.162a27 27 0 0 0-.421 4.29 5.25 5.25 0 0 1-2.092-1.282l-.884.884a6.5 6.5 0 0 0 9.192 0l-.884-.884a5.25 5.25 0 0 1-4.335 1.5q.003-.342.017-.712a25.4 25.4 0 0 1 .391-3.614c.085-.46.187-.926.309-1.386.314-1.192.757-2.353 1.378-3.334L15.028.5c-.498.787-.878 1.737-1.163 2.754C19.02 3.925 23 8.331 23 13.667c0 5.799-4.701 10.5-10.5 10.5S2 19.466 2 13.667"
      ></path>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="transparent" d="M.5 0h24v24H.5z"></path>
      </clipPath>
    </defs>
  </svg>
);
